import React from 'react';
import { Link } from 'react-router-dom';

const Documents = () => {
  return (
    <main className="bg-white min-h-screen p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Documents</h1>
      <div className="max-w-md mx-auto space-y-4">
        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">12A Registration</h2>
          <p>This document certifies the registration under 12A.</p>
          <a
            href="/pdf/12a-jmb-bhachau-registration.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>
        
        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">80G Certificate</h2>
          <p>This certificate confirms exemption under Income Tax 80-G.</p>
          <a
            href="/pdf/80g-certificate-jmb-bhachau.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>

        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">AAATJ1447J Registration Profile</h2>
          <p>Registration profile document for AAATJ1447J.</p>
          <a
            href="/pdf/registration_profile.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>

        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">CSR Activities Certificate</h2>
          <p>Certificate for CSR activities by Jivdaya Mandal Bhachau Kanaksuri Ahinsadham.</p>
          <a
            href="/pdf/CSR ACTIVITIES CERTIFICATE JIVDAYA MANDAL BHACHAU KANAKSURI AHINSADHAM.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>

        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">PAN Card</h2>
          <p>Official PAN card document.</p>
          <a
            href="/pdf/PAN CARD.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>

        <div className="border p-4 rounded shadow">
          <h2 className="text-xl font-semibold mb-2">Trust Registration Certificate</h2>
          <p>Trust registration certificate with English translation for Kanaksuri Ahinsadham.</p>
          <a
            href="/pdf/trust registration certificate with english kanaksuri ahinsadham.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            View Document
          </a>
        </div>
      </div>
      
      <div className="text-center mt-6">
        <Link to="/" className="text-primary underline">Back to Home</Link>
      </div>
    </main>
  );
};

export default Documents;